export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeDeliveryInfo: {
        noticeDeliveryAt: 1234567890123,
        serviceName: "アイラ地域サポート",
        deliveryToKbn: 1,
        deliveryToAttributeGroupNames: ['属性グループ名'],
        deliveryStatus: 4,
        deliveryLocationCount: 141,
        openedLocationCount: 41,
        thumbupLocationCount: 39,
        deliverySpCount: 1200,
        openedSpCount: 722,
        thumbupSpCount: 697
      },
      deliveryContents: {
        title: '音声定時放送',
        body: 'xxxxx',
        attachments: [],
        soundFile: [],
        linkUrl: 'http://www.google.co.jp',
        question: 'xxxxx',
        answerOptions: [],
        keikaiLevel: 0
      },
      deliveryTypeMstUuid: 'deliverytypemst001',
      noticeTypeMstUuid: 'noticeType007',
    }
  }
}